import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "bca_logo_el",
  "use": "bca_logo_el-usage",
  "viewBox": "0 0 108.57 81.86",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 108.57 81.86\" id=\"bca_logo_el\">\n    <path fill=\"currentColor\" d=\"M0 0h46.41v10.43H11.72v24.96h33.52v10.49H11.72v25.43h35.8v10.43H0V0zM60 0h11.72v71.19h36.86v10.66H60V0z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol